"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueCustomFieldOptionsApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class IssueCustomFieldOptionsApi extends runtime.BaseAPI {
    /**
     * Creates options and, where the custom select field is of the type Select List (cascading), cascading options for a custom select field. The options are added to a context of the field.  The maximum number of options that can be created per request is 1000 and each field can have a maximum of 10000 options.  This operation works for custom field options created in Jira or the operations from this resource. **To work with issue field select list options created for Connect apps use the [Issue custom field options (apps)](#api-group-issue-custom-field-options--apps-) operations.**  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Create custom field options (context)
     */
    createCustomFieldOptionRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fieldId'] == null) {
                throw new runtime.RequiredError('fieldId', 'Required parameter "fieldId" was null or undefined when calling createCustomFieldOption().');
            }
            if (requestParameters['contextId'] == null) {
                throw new runtime.RequiredError('contextId', 'Required parameter "contextId" was null or undefined when calling createCustomFieldOption().');
            }
            if (requestParameters['bulkCustomFieldOptionCreateRequest'] == null) {
                throw new runtime.RequiredError('bulkCustomFieldOptionCreateRequest', 'Required parameter "bulkCustomFieldOptionCreateRequest" was null or undefined when calling createCustomFieldOption().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/{fieldId}/context/{contextId}/option`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))).replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters['contextId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.BulkCustomFieldOptionCreateRequestToJSON)(requestParameters['bulkCustomFieldOptionCreateRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CustomFieldCreatedContextOptionsListFromJSON)(jsonValue));
        });
    }
    /**
     * Creates options and, where the custom select field is of the type Select List (cascading), cascading options for a custom select field. The options are added to a context of the field.  The maximum number of options that can be created per request is 1000 and each field can have a maximum of 10000 options.  This operation works for custom field options created in Jira or the operations from this resource. **To work with issue field select list options created for Connect apps use the [Issue custom field options (apps)](#api-group-issue-custom-field-options--apps-) operations.**  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Create custom field options (context)
     */
    createCustomFieldOption(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCustomFieldOptionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Deletes a custom field option.  Options with cascading options cannot be deleted without deleting the cascading options first.  This operation works for custom field options created in Jira or the operations from this resource. **To work with issue field select list options created for Connect apps use the [Issue custom field options (apps)](#api-group-issue-custom-field-options--apps-) operations.**  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Delete custom field options (context)
     */
    deleteCustomFieldOptionRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fieldId'] == null) {
                throw new runtime.RequiredError('fieldId', 'Required parameter "fieldId" was null or undefined when calling deleteCustomFieldOption().');
            }
            if (requestParameters['contextId'] == null) {
                throw new runtime.RequiredError('contextId', 'Required parameter "contextId" was null or undefined when calling deleteCustomFieldOption().');
            }
            if (requestParameters['optionId'] == null) {
                throw new runtime.RequiredError('optionId', 'Required parameter "optionId" was null or undefined when calling deleteCustomFieldOption().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/{fieldId}/context/{contextId}/option/{optionId}`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))).replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters['contextId']))).replace(`{${"optionId"}}`, encodeURIComponent(String(requestParameters['optionId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Deletes a custom field option.  Options with cascading options cannot be deleted without deleting the cascading options first.  This operation works for custom field options created in Jira or the operations from this resource. **To work with issue field select list options created for Connect apps use the [Issue custom field options (apps)](#api-group-issue-custom-field-options--apps-) operations.**  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Delete custom field options (context)
     */
    deleteCustomFieldOption(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.deleteCustomFieldOptionRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Returns a custom field option. For example, an option in a select list.  Note that this operation **only works for issue field select list options created in Jira or using operations from the [Issue custom field options](#api-group-Issue-custom-field-options) resource**, it cannot be used with issue field select list options created by Connect apps.  This operation can be accessed anonymously.  **[Permissions](#permissions) required:** The custom field option is returned as follows:   *  if the user has the *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).  *  if the user has the *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for at least one project the custom field is used in, and the field is visible in at least one layout the user has permission to view.
     * Get custom field option
     */
    getCustomFieldOptionRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling getCustomFieldOption().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/customFieldOption/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CustomFieldOptionFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a custom field option. For example, an option in a select list.  Note that this operation **only works for issue field select list options created in Jira or using operations from the [Issue custom field options](#api-group-Issue-custom-field-options) resource**, it cannot be used with issue field select list options created by Connect apps.  This operation can be accessed anonymously.  **[Permissions](#permissions) required:** The custom field option is returned as follows:   *  if the user has the *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).  *  if the user has the *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for at least one project the custom field is used in, and the field is visible in at least one layout the user has permission to view.
     * Get custom field option
     */
    getCustomFieldOption(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomFieldOptionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns a [paginated](#pagination) list of all custom field option for a context. Options are returned first then cascading options, in the order they display in Jira.  This operation works for custom field options created in Jira or the operations from this resource. **To work with issue field select list options created for Connect apps use the [Issue custom field options (apps)](#api-group-issue-custom-field-options--apps-) operations.**  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get custom field options (context)
     */
    getOptionsForContextRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fieldId'] == null) {
                throw new runtime.RequiredError('fieldId', 'Required parameter "fieldId" was null or undefined when calling getOptionsForContext().');
            }
            if (requestParameters['contextId'] == null) {
                throw new runtime.RequiredError('contextId', 'Required parameter "contextId" was null or undefined when calling getOptionsForContext().');
            }
            const queryParameters = {};
            if (requestParameters['optionId'] != null) {
                queryParameters['optionId'] = requestParameters['optionId'];
            }
            if (requestParameters['onlyOptions'] != null) {
                queryParameters['onlyOptions'] = requestParameters['onlyOptions'];
            }
            if (requestParameters['startAt'] != null) {
                queryParameters['startAt'] = requestParameters['startAt'];
            }
            if (requestParameters['maxResults'] != null) {
                queryParameters['maxResults'] = requestParameters['maxResults'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/{fieldId}/context/{contextId}/option`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))).replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters['contextId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PageBeanCustomFieldContextOptionFromJSON)(jsonValue));
        });
    }
    /**
     * Returns a [paginated](#pagination) list of all custom field option for a context. Options are returned first then cascading options, in the order they display in Jira.  This operation works for custom field options created in Jira or the operations from this resource. **To work with issue field select list options created for Connect apps use the [Issue custom field options (apps)](#api-group-issue-custom-field-options--apps-) operations.**  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Get custom field options (context)
     */
    getOptionsForContext(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOptionsForContextRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Changes the order of custom field options or cascading options in a context.  This operation works for custom field options created in Jira or the operations from this resource. **To work with issue field select list options created for Connect apps use the [Issue custom field options (apps)](#api-group-issue-custom-field-options--apps-) operations.**  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Reorder custom field options (context)
     */
    reorderCustomFieldOptionsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fieldId'] == null) {
                throw new runtime.RequiredError('fieldId', 'Required parameter "fieldId" was null or undefined when calling reorderCustomFieldOptions().');
            }
            if (requestParameters['contextId'] == null) {
                throw new runtime.RequiredError('contextId', 'Required parameter "contextId" was null or undefined when calling reorderCustomFieldOptions().');
            }
            if (requestParameters['orderOfCustomFieldOptions'] == null) {
                throw new runtime.RequiredError('orderOfCustomFieldOptions', 'Required parameter "orderOfCustomFieldOptions" was null or undefined when calling reorderCustomFieldOptions().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/{fieldId}/context/{contextId}/option/move`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))).replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters['contextId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.OrderOfCustomFieldOptionsToJSON)(requestParameters['orderOfCustomFieldOptions']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Changes the order of custom field options or cascading options in a context.  This operation works for custom field options created in Jira or the operations from this resource. **To work with issue field select list options created for Connect apps use the [Issue custom field options (apps)](#api-group-issue-custom-field-options--apps-) operations.**  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Reorder custom field options (context)
     */
    reorderCustomFieldOptions(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.reorderCustomFieldOptionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates the options of a custom field.  If any of the options are not found, no options are updated. Options where the values in the request match the current values aren\'t updated and aren\'t reported in the response.  Note that this operation **only works for issue field select list options created in Jira or using operations from the [Issue custom field options](#api-group-Issue-custom-field-options) resource**, it cannot be used with issue field select list options created by Connect apps.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Update custom field options (context)
     */
    updateCustomFieldOptionRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['fieldId'] == null) {
                throw new runtime.RequiredError('fieldId', 'Required parameter "fieldId" was null or undefined when calling updateCustomFieldOption().');
            }
            if (requestParameters['contextId'] == null) {
                throw new runtime.RequiredError('contextId', 'Required parameter "contextId" was null or undefined when calling updateCustomFieldOption().');
            }
            if (requestParameters['bulkCustomFieldOptionUpdateRequest'] == null) {
                throw new runtime.RequiredError('bulkCustomFieldOptionUpdateRequest', 'Required parameter "bulkCustomFieldOptionUpdateRequest" was null or undefined when calling updateCustomFieldOption().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["manage:jira-configuration"]);
            }
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            const response = yield this.request({
                path: `/rest/api/3/field/{fieldId}/context/{contextId}/option`.replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters['fieldId']))).replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters['contextId']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.BulkCustomFieldOptionUpdateRequestToJSON)(requestParameters['bulkCustomFieldOptionUpdateRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CustomFieldUpdatedContextOptionsListFromJSON)(jsonValue));
        });
    }
    /**
     * Updates the options of a custom field.  If any of the options are not found, no options are updated. Options where the values in the request match the current values aren\'t updated and aren\'t reported in the response.  Note that this operation **only works for issue field select list options created in Jira or using operations from the [Issue custom field options](#api-group-Issue-custom-field-options) resource**, it cannot be used with issue field select list options created by Connect apps.  **[Permissions](#permissions) required:** *Administer Jira* [global permission](https://confluence.atlassian.com/x/x4dKLg).
     * Update custom field options (context)
     */
    updateCustomFieldOption(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateCustomFieldOptionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.IssueCustomFieldOptionsApi = IssueCustomFieldOptionsApi;
//# sourceMappingURL=IssueCustomFieldOptionsApi.js.map